import { useEffect, useState } from "react";
import { Link, useParams, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Star, Check } from "lucide-react";
import { http, errMsg } from "../lib/api";
import Seo from "../components/Seo";

function ReviewForm({ item, orderId, t, first, onDone }) {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [title, setTitle] = useState("");
  const [text, setText] = useState("");
  const [name, setName] = useState(first || "");
  const [showCity, setShowCity] = useState(false);
  const [busy, setBusy] = useState(false);
  const inp = "mt-1 w-full border border-[#E5E0D8] rounded-xl px-3 py-2.5 text-sm bg-white";
  const send = async () => {
    setBusy(true);
    try { await http.post("/reviews", { order_id: orderId, t, product_id: item.product_id, rating, title, text, name, show_city: showCity }); toast.success("Dank je wel! Je review verschijnt na een korte controle."); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="space-y-4 mt-4">
      <div className="flex gap-1" onMouseLeave={() => setHover(0)}>
        {[1, 2, 3, 4, 5].map((i) => <button key={i} type="button" aria-label={`${i} sterren`} onMouseEnter={() => setHover(i)} onClick={() => setRating(i)} data-testid={`review-star-${item.product_id}-${i}`}>
          <Star size={28} className={i <= (hover || rating) ? "fill-[#B78B7B] text-[#B78B7B]" : "text-[#D8CFC6]"} /></button>)}
      </div>
      <label className="block text-xs text-[#6E747B]">Titel (optioneel)<input className={inp} maxLength={80} value={title} onChange={(e) => setTitle(e.target.value)} data-testid={`review-title-${item.product_id}`} /></label>
      <label className="block text-xs text-[#6E747B]">Je ervaring<textarea className={inp + " min-h-[110px]"} maxLength={1500} value={text} onChange={(e) => setText(e.target.value)} placeholder="Hoe ligt de vloer erbij? Hoe ging het leggen?" data-testid={`review-text-${item.product_id}`} /></label>
      <label className="block text-xs text-[#6E747B]">Je naam zoals getoond<input className={inp} maxLength={40} value={name} onChange={(e) => setName(e.target.value)} data-testid={`review-name-${item.product_id}`} /></label>
      <label className="flex items-center gap-2 text-xs text-[#6E747B]"><input type="checkbox" className="accent-[#B78B7B]" checked={showCity} onChange={(e) => setShowCity(e.target.checked)} data-testid={`review-show-city-${item.product_id}`} /> Toon mijn woonplaats bij de review</label>
      <button disabled={busy || !rating || text.trim().length < 10 || name.trim().length < 2} onClick={send} data-testid={`review-submit-${item.product_id}`}
        className="bg-[#34393E] hover:bg-[#B78B7B] disabled:bg-[#9AA0A6] text-white rounded-xl px-6 py-3 text-sm font-medium transition-colors">{busy ? "Versturen…" : "Review plaatsen"}</button>
    </div>
  );
}

export default function ReviewPage() {
  const { orderId } = useParams();
  const [sp] = useSearchParams();
  const t = sp.get("t");
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const load = () => http.get(`/reviews/order/${orderId}`, { params: { t } }).then((r) => setD(r.data)).catch((e) => setErr(errMsg(e)));
  useEffect(() => { load(); }, [orderId, t]); // eslint-disable-line
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14" data-testid="review-page">
      <Seo title="Schrijf een review" noindex />
      <p className="eyebrow">Jouw ervaring</p>
      <h1 className="font-serif-brand text-4xl sm:text-5xl mt-2">{d ? `Hoe bevalt je vloer, ${d.name}?` : "Schrijf een review"}</h1>
      {err && <p className="mt-8 bg-white rounded-2xl p-6 text-sm" data-testid="review-page-error">{err}</p>}
      {d && <p className="text-sm text-[#5A5550] mt-4">Bestelling {d.number}. Je review wordt kort gecontroleerd en daarna bij de vloer getoond als geverifieerde aankoop.</p>}
      <div className="space-y-5 mt-10">
        {d?.items.map((i) => (
          <div key={i.product_id} className="bg-white rounded-3xl p-6" data-testid={`review-item-${i.product_id}`}>
            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-2xl overflow-hidden bg-[#EFE8E0] shrink-0">{i.image && <img src={i.image} alt="" className="w-full h-full object-cover" />}</div>
              <Link to={`/product/${i.slug}`} className="font-medium hover:text-[#B78B7B]">{i.name}</Link>
            </div>
            {i.reviewed ? <p className="mt-4 text-sm text-[#2E7D32] flex items-center gap-2" data-testid={`review-done-${i.product_id}`}><Check size={16} /> Bedankt, je review is ontvangen.</p>
              : <ReviewForm item={i} orderId={orderId} t={t} first={d.name} onDone={load} />}
          </div>
        ))}
      </div>
    </div>
  );
}
